import { Injectable } from '@angular/core';
import { AdpReportModel, ClassesAttendanceReportModel, ClassesReportModel, GetAdpReportQuery, GetAttendanceReportFileQuery, GetAttendanceReportQuery, GetClubCentricReportFileQuery, GetClubCentricReportQuery, GetInstructorCentricReportFileQuery, GetInstructorCentricReportQuery, GetOnlineContentViewReportFileQuery, GetOnlineContentViewReportQuery, GetPayrollReportFileQuery, GetPayrollReportQuery, OnlineContentViewsReportModel } from '@bayclubs/group-classes-employee-api';
import { QueryStringBuilder } from '@bayclubs/utils';
import { ManagementHttpClient } from 'src/app/shared/shared.module';

@Injectable({
    providedIn: 'root'
})
export class ReportsService {
    constructor(private http: ManagementHttpClient) {}

    getClubCentricReportData(filter: GetClubCentricReportQuery) {
        return this.http.get<ClassesReportModel>(
            `reports/club-centric?` + QueryStringBuilder.buildParametersFromSearch(filter).toString(),
            true
        );
    }

    generateClubCentricReportFile(filter: GetClubCentricReportFileQuery) {
        return this.http.getFileRequest(
            `reports/club-centric-file?` + QueryStringBuilder.buildParametersFromSearch(filter).toString()
        );
    }

    getPayrollReportData(filter: GetPayrollReportQuery) {
        return this.http.get<ClassesReportModel>(
            `reports/payroll?` + QueryStringBuilder.buildParametersFromSearch(filter).toString(),
            true
        );
    }

    generatePayrollReportFile(filter: GetPayrollReportFileQuery) {
        return this.http.getFileRequest(
            `reports/payroll-file?` + QueryStringBuilder.buildParametersFromSearch(filter).toString()
        );
    }

    generateAdpExtractReportFile(filter: GetPayrollReportFileQuery) {
        return this.http.getFileRequest(
            `reports/adp-extract-file?` + QueryStringBuilder.buildParametersFromSearch(filter).toString()
        );
    }

    getAttendanceReportData(filter: GetAttendanceReportQuery) {
        return this.http.post<ClassesAttendanceReportModel>(`reports/attendance`, filter, true);
    }

    generateAttendanceReportFile(filter: GetAttendanceReportFileQuery) {
        return this.http.postFileRequest(`reports/attendance-file`, filter);
    }

    getInstructorCentricReportData(filter: GetInstructorCentricReportQuery) {
        return this.http.post<ClassesReportModel>(`reports/instructor-centric`, filter, true);
    }

    generateInstructorCentricReportFile(filter: GetInstructorCentricReportFileQuery) {
        return this.http.postFileRequest(`reports/instructor-centric-file`, filter);
    }

    getOnlineContentViewReportData(filter: GetOnlineContentViewReportQuery) {
        return this.http.post<OnlineContentViewsReportModel>(`reports/online-content-view`, filter, true);
    }

    generateOnlineContentViewReportFile(filter: GetOnlineContentViewReportFileQuery) {
        return this.http.postFileRequest(`reports/online-content-view-file`, filter);
    }

    getAdpReportData(filter: GetAdpReportQuery) {
        return this.http.get<AdpReportModel>(
            `reports/adp?` + QueryStringBuilder.buildParametersFromSearch(filter).toString(),
            true
        );
    }

    generateAdpReportFile(filter: GetAdpReportQuery) {
        return this.http.getFileRequest(
            `reports/adp-file?` + QueryStringBuilder.buildParametersFromSearch(filter).toString()
        );
    }
}
